import {
	AT,
	BE,
	BG,
	CH,
	CN,
	CZ,
	DE,
	ES,
	FI,
	FR,
	HU,
	IL,
	IT,
	JP,
	KR,
	LT,
	MX,
	NL,
	NO,
	PL,
	SI,
	SK,
	TR,
	UA,
	US,
} from "country-flag-icons/string/3x2";
import { Country } from "../schema/Country.js";

export const countryEmojiMap: Record<Country, string> = {
	[Country.Czechia]: CZ,
	[Country.Poland]: PL,
	[Country.Germany]: DE,
	[Country.Slovakia]: SK,
	[Country.Ukraine]: UA,
	[Country.Italy]: IT,
	[Country.Belgium]: BE,
	[Country.France]: FR,
	[Country.Israel]: IL,
	[Country.Japan]: JP,
	[Country.Austria]: AT,
	[Country.Slovenia]: SI,
	[Country.Spain]: ES,
	[Country.Switzerland]: CH,
	[Country.Bulgaria]: BG,
	[Country.China]: CN,
	[Country.Finland]: FI,
	[Country.Korea]: KR, // South Korea assumed
	[Country.Lithuania]: LT,
	[Country.Hungary]: HU,
	[Country.Mexico]: MX,
	[Country.Norway]: NO,
	[Country.Netherlands]: NL,
	[Country.Turkey]: TR,
	[Country.USA]: US,
};
